import WaterMark from './components/WaterMark';
import { Watermark} from './components/index';
import {extend} from 'flarum/extend';
import PostStream from 'flarum/components/PostStream';
import app from 'flarum/app';
import Navigation from 'flarum/components/Navigation';

app.initializers.add('annonny/flarum-watermark', () => {
  var waterMark: any;
  var secretWaterMark: any;
  extend(PostStream.prototype, 'view', function (this: PostStream, vdom: any) {
    if (!secretWaterMark) {
      let currentUserId = "";
      if (app.session.user) {
        currentUserId = currentUserId + app.session.user.id();
      }
      const watermarkConfig = {
        monitor: false,
        blindText: currentUserId,
        blindFontSize: 30,
        blindOpacity: 0.005,
      }
      secretWaterMark = new Watermark(watermarkConfig);
    } else {
      secretWaterMark.show();
    }
    if (this.discussion.tags().some(tag => tag.slug() === 'shudong')) {
      if (!waterMark) {
        let currentUserId = "uid:";
        if (app.session.user) {
          currentUserId = currentUserId + app.session.user.id();
        }
        waterMark = new WaterMark(document.getElementsByTagName('body')[0], {
          text: currentUserId,
          color: "rgb(128, 128, 128)",
          fontSize: 16
        });
      } else {
        waterMark.show();
      }
    }else{
      if (waterMark) {
        waterMark.hide();
      }
    }
  });

  extend(Navigation.prototype, 'onupdate', function (this: Navigation, vnode: any) {
    // 当路由发生变化时
    if (this.previousPath !== m.route.get()) {
      if (waterMark) {
        waterMark.hide();
      }
    }
    // 记录当前路径
    this.previousPath = m.route.get();
  });
});
